import type {ProductCharacteristic} from "#sitis/internal/controllers/products/models/Product";

const getCharFromRedactor = (characteristic: ProductCharacteristic) => {
  if (!characteristic) {
    return
  }
  return Boolean( characteristic?.filterType === 6)
}
export default getCharFromRedactor;
